export default __webpack_public_path__ + "static/media/pasta.1aae9366.png";